import { HTMLAttributes, useState } from 'react'
import {
  BackgroundColorProps,
  DisplayProps,
  PositionProps,
  SpaceProps,
} from 'styled-system'

import { TestIdProps } from 'designSystem/types/propTypes'

import { COLOR } from 'designSystem/foundations/constants/color'
import { SIZE } from 'designSystem/foundations/constants/size'

import PDSText from '../PDSText/PDSText'
import INTERNALxGroupButton from '../internal/INTERNALxGroupButton'
import INTERNALxDiv from '../internal/elements/INTERNALxDiv'
import INTERNALxLabel from '../internal/elements/INTERNALxLabel'

type ControlGroupSize = 'sm' | 'md' | 'lg'

type BaseProps = HTMLAttributes<HTMLDivElement> &
  BackgroundColorProps &
  DisplayProps &
  SpaceProps &
  PositionProps &
  TestIdProps

type Props<T> = {
  defaultValue?: boolean | number | string
  label: string
  mainOnClick?: (o: PDSControlGroupOption<T>) => void
  options: PDSControlGroupOption<T>[]
  size?: ControlGroupSize
  testId?: string
} & BaseProps

export type PDSControlGroupOption<T> = {
  label: string
  onClick?: Function
  value: T
}

export default function PDSControlGroup<T = string>({
  defaultValue,
  label,
  size = 'md',
  mainOnClick,
  options,
  testId,
}: Props<T>) {
  const [selectedValue, setSelectedValue] = useState<T | undefined>(
    defaultValue as T
  )

  const mainHandler = (o: PDSControlGroupOption<T>) => {
    setSelectedValue(o.value)
    mainOnClick?.(o)
    o.onClick?.(o)
  }

  return (
    <INTERNALxDiv
      alignItems="center"
      display="flex"
      gap={SIZE.s4}
      testId={testId}
    >
      <INTERNALxLabel alignItems="center" display="flex" marginRight={SIZE.s4}>
        <PDSText
          color={COLOR.textSecondary}
          size={size}
          weight="medium"
          whiteSpace="nowrap"
        >{`${label}:`}</PDSText>
      </INTERNALxLabel>
      {options.map((o, i) => (
        <INTERNALxGroupButton
          key={`${i}-${o.label}-group-button`}
          isActive={o.value === selectedValue}
          onClick={() => mainHandler(o)}
          size={size}
          testId={testId && `${testId}-${o.label}-group-button`}
          text={o.label}
        />
      ))}
    </INTERNALxDiv>
  )
}
